var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("form-label", {
    attrs: { label: _vm.label, "class-name": _vm.formLabelClassName },
    scopedSlots: _vm._u(
      [
        {
          key: "label",
          fn: function () {
            return [_vm._t("label")]
          },
          proxy: true,
        },
        {
          key: "header",
          fn: function () {
            return [_vm._t("header")]
          },
          proxy: true,
        },
        {
          key: "body",
          fn: function () {
            return [
              _c(
                "fieldset",
                { staticClass: "pega-welcome-questions-wrap" },
                [
                  _vm._l(_vm.options, function (option, i) {
                    return [
                      _c(
                        "label",
                        {
                          key: i,
                          staticClass: "pega-input pega-questions-column",
                        },
                        [
                          _c("input", {
                            attrs: {
                              "data-test": "option-" + i,
                              type: "checkbox",
                              name: "form-item-group",
                            },
                            domProps: {
                              value: option.id,
                              checked: _vm.value.includes(option.id),
                            },
                            on: { change: _vm.update },
                          }),
                          _c("span", [
                            _vm._v(
                              "\n            " +
                                _vm._s(option.name) +
                                "\n          "
                            ),
                          ]),
                        ]
                      ),
                    ]
                  }),
                ],
                2
              ),
            ]
          },
          proxy: true,
        },
        {
          key: "error",
          fn: function () {
            return [_vm._t("error")]
          },
          proxy: true,
        },
      ],
      null,
      true
    ),
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }